import ArticleContent from './articleContent';

export default ArticleContent;
